import { SubBar } from './SubBar';
import { DesignRoutes } from './DesignRoutes';
import { SearchBar } from './SearchBar';
import { useStyles } from './styles/DesignBar.styles';

interface DefaultDesignBarProps {
    onSearch: (searchText: string) => void;
    selectedRoute: string;
    children: React.ReactNode;
}

export const DefaultDesignBar = ({ onSearch, selectedRoute, children }: DefaultDesignBarProps) => {
    const styles = useStyles();

    return (
        <SubBar>
            <div className={styles.searchContainer}>
                <SearchBar onSearch={onSearch} />

                {children}
            </div>

            <div className={styles.routesContainer}>
                <DesignRoutes selectedRoute={selectedRoute} />
            </div>
        </SubBar>
    );
};
